
var PROJ = (typeof PROJ === 'object') ? PROJ : {};
PROJ.pdp = {
    VAR: {},
    init: function () {
        var _this = this;

        document.querySelectorAll('form[action="/cart/add"].pdp-form-class').forEach(function(form) {
            form.addEventListener('submit', function(e) {
                e.preventDefault();

                // check form is completed
                form.querySelector('.warning-text').textContent = "";
                var noComplete = false;

                form.querySelectorAll('.pdp-property').forEach(function (inp) {
                  if(inp.value == "")
                  {
                      noComplete = true;
                  }
                });

                if(noComplete)
                {
                    form.querySelector('.warning-text').textContent = "Please Select All Options";
                    return;
                }

                var addToCartBtn = form.querySelector('.addtocart');

                addToCartBtn.classList.add('disabled');
                addToCartBtn.disabled = true;

                var formData = new FormData(form);

                PROJ.ajaxcart.opencart();
                document.getElementById('mini-cart').classList.add('loading');
                fetch('/cart/add.js', {
                    method: 'POST',
                    body: new URLSearchParams(formData),
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                    }
                })
                    .then(response => response.json())
                    .then(data => {
                        PROJ.ajaxcart.updateCart();
                        addToCartBtn.classList.remove('disabled');
                        addToCartBtn.disabled = false;
                    })
                    .catch(error => {
                        PROJ.ajaxcart.updateCart();
                        document.getElementById('mini-cart').classList.remove('loading');
                        console.error('Error adding item to cart:', error);
                    });
            });
        });

        // Shopify default option selector to change variables
        document.querySelectorAll('.slp-details .pr-product-form .ops-default').forEach(function(item) {
            item.addEventListener('change', function(e) {
                e.preventDefault();

                this.closest('.op-wrap').querySelectorAll('.ops-default').forEach(function(child) {
                    child.classList.remove('active');
                });
                this.classList.add('active');

                var formval = "";
                var thisForm = this.closest('.pdp-form-wrap');
                var allselected = true;
                thisForm.querySelectorAll('.ops-default').forEach(function(child) {
                    formval += child.value;
                    if(!child.value) allselected = false;
                });
                if(allselected)
                {
                    var thisopr = thisForm.querySelector('[data-options="'+formval+'"]');
                    var varid = thisopr.getAttribute('value');
                    var pricetag = thisopr.getAttribute('data-var-price');
                    thisForm.querySelector('.pr-variants').value = varid;
                    thisForm.querySelector('.pdp-price-tag').innerHTML = pricetag;
                }

            });
        });



    },
    checkForm: function () {

    },
    updateCart: function () {
        location.reload();
    }
};

PROJ.ajaxcart = {
    VAR: {},

    init: function () {
        var _this = this;

        var walletElement = document.querySelector('[wallet-configs]');
        if (walletElement) {
            var quickpay = JSON.parse(walletElement.getAttribute('wallet-configs'));
            var miniCart = document.getElementById('mini-cart');
            if (miniCart && Array.isArray(quickpay)) {
                for (var s = 0; s < quickpay.length; s++) {
                    miniCart.classList.add(quickpay[s].name);
                }
            }
        }

        setTimeout(function(){
            _this.reloadOfferbar();
            _this.animateCart();
        },100);

        //auto open minicart
        if (window.location.href.includes("minicart=true")) {
            document.documentElement.classList.add('mini-cart');
            document.body.classList.add('mini-cart');

            setTimeout(() => {
                document.documentElement.classList.add('mini-cart-ani');
                document.body.classList.add('mini-cart-ani');
            }, 500);
        }



        ['click'].forEach(eventType => {
            document.body.addEventListener(eventType, function(e) {
                let clicked = e.target;
                if (e.target.closest('a.mini_cart, .opencart, [href="/cart"]')) {
                   e.preventDefault();
                   e.stopPropagation();
                  _this.opencart();
                }
                if (e.target.closest('.nav-close-cart, .minicart-back')) {
                    e.preventDefault();
                    e.stopPropagation();
                    _this.closecart();
                }
                //remove from cart
                if (e.target.classList.contains('remove') && e.target.closest('.incart')) {
                    e.preventDefault();
                    let par = e.target.closest('.incart');
                    let qty = 0;
                    _this.updateItem(par.getAttribute('data-item-key'), qty);
                }
                if (clicked.closest('.openpays')) {
                    e.preventDefault();
                    e.stopPropagation();
                    document.querySelector('#mini-cart')?.classList.toggle('quickpay');

                }

                //Hide Complet the set
                if (e.target.classList.contains('hide-cts')) {
                    e.preventDefault();
                    document.body.classList.add('hide-cts-cart');
                }
                if (clicked.classList.contains('qty-step-btn')) {
                    e.preventDefault();
                    let input = clicked.closest('.mcart-item').querySelector('.qty-input');
                    if (input) {
                        let currentValue = parseInt(input.value, 10) || 0;

                        if (clicked.classList.contains('plus')) {
                            input.value = currentValue + 1;
                        } else if (clicked.classList.contains('minus') && currentValue > 0) {
                            input.value = currentValue - 1;
                        }

                        _this.updateItem(input.getAttribute('data-proid'), input.value);
                    }
                }
                if (clicked.getAttribute('data-directadd')) {
                    e.preventDefault();
                    _this.addItem(clicked.getAttribute('data-directadd'));
                };

                if (clicked.closest("[data-protection-id]"))
                {
                    const clickedPro = clicked.closest("[data-protection-id]");
                    e.preventDefault();
                    const protectionId = clickedPro.getAttribute("data-protection-id");
                    if (clickedPro.classList.contains("active")) {
                        sessionStorage.removeItem("sps");
                        _this.updateItem(protectionId, 0);
                    } else {
                        sessionStorage.setItem("sps", "true");
                        _this.addItem(protectionId);
                    }
                }

            });
        });

        document.body.addEventListener('change', function (e) {
            let input = e.target;
            //change input in minicart items
            if (input.matches('.mcart-item [data-proid].qty-input')) {
                e.preventDefault();
                _this.updateItem(input.getAttribute('data-proid'), input.value);
            }

            if (input.matches(".ccs-select select")) {
                let details = input.closest(".details");
                if (!details) return;
                document.getElementById('mini-cart').classList.add('loading');

                let variantId = details.getAttribute("data-ccs");
                let properties = { "Size": input.value };

                details.querySelectorAll(".ccs-option").forEach(option => {
                    let [name, value] = option.textContent.split(":").map(t => t.trim());
                    if (name && value) properties[name] = value;
                });

                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: variantId, quantity: 1, properties })
                })
                    .then(res => res.json())
                    .then(() => _this.updateCart())
                    .catch(() => alert("Failed to add item."));
            }
        });




    },
    opencart: function () {

        document.querySelectorAll('body,html').forEach(item => {
            item.classList.add('mini-cart');
            setTimeout(function(){
                item.classList.add('mini-cart-ani');
            },500);
        });

    },
    closecart: function () {

        document.querySelectorAll('body,html').forEach(item => {
            item.classList.remove('mini-cart');
            setTimeout(function(){
                item.classList.remove('mini-cart-ani');
            },500);
        });

    },
    updateCart: function () {
        var _this = this;
        document.querySelectorAll('body, html').forEach(item => {
            item.classList.remove('mini-cart-ani');
        });

        fetch("/cart?view=mini")
            .then(function (response) {
                return response.text();
            })
            .then(function (data) {
                document.querySelector('#mini-cart .ajax_place').innerHTML = data;

            // Update .cart-counts with data-icount, but only if .cart-counts has data-icount attribute (and not inside mini-cart)
            var cartCountEl = document.querySelector('.cart-counts');
            var getCounts = document.querySelector('[data-icount]');
            if (cartCountEl && getCounts) {
                var icount = getCounts.getAttribute('data-icount');
                cartCountEl.textContent = icount !== null ? icount : '';
            }


            })
            .then(function () {
                // Call the animateCart function
                _this.animateCart();
                _this.opencart();
                // Remove the loading class
                document.getElementById('mini-cart').classList.remove('loading');

                // Add the mini-cart-ani class to the body
                document.body.classList.add('mini-cart-ani');
                document.documentElement.classList.add('mini-cart-ani');
            })
            .catch(function (error) {
                console.error('Error fetching cart:', error);
            });



    }, animateCart: function () {
        // to update and animate mini cart with total price
        var _this = this;

        //check shiping protection
        const spitem = document.querySelector('[data-spchange]');
        if(spitem && sessionStorage.getItem('sps'))
        {

            const spitemdata = spitem.getAttribute("data-spchange");
            document.getElementById('mini-cart').classList.add('loading');
            document.body.classList.remove('mini-cart-ani');
            document.documentElement.classList.remove('mini-cart-ani');
            fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: spitemdata,
            })
                .then((response) => {
                    if (!response.ok) throw new Error('Network response was not ok');
                    return response.json();
                })
                .then(() => {
                    _this.updateCart();
                })
                .catch(() => {
                    _this.updateCart();
                });
            return;
        }


        const vtarget = document.querySelector('.target-gifts');
        const vgift   = document.querySelector('.ns-target-gift');

        if (vtarget && vgift) {
            vtarget.appendChild(vgift);
        }


        var locks = document.querySelectorAll('.target-locks .target');
        var rate = window.market_exchange_rate ?? 1;
        var progess_bar_val = document.querySelector('.ns-progress')?.dataset.progress;// total price
        var gifts = document.querySelectorAll('.ns-target-gift');

        gifts.forEach(target => {

            if (progess_bar_val >= (target.getAttribute('data-gift-target') * rate) && target.classList.contains('noproduct')) {
                target.classList.add('gifttrue');
                if(target.querySelector('.cafter'))  target.querySelector('.cafter').style.display = 'block';
            } else {
                if(target.querySelector('.cbefore'))  target.querySelector('.cbefore').style.display = 'block';
            }

            if(progess_bar_val >= (target.getAttribute('data-gift-target')*rate) && target.classList.contains('giftfalse') && target.classList.contains('noappgift'))
            {
                _this.addItem(target.getAttribute('data-gift-id'));
                return;
            }else if (progess_bar_val < (target.getAttribute('data-gift-target')*rate) && target.classList.contains('gifttrue') )
            {
                _this.updateItem(target.getAttribute('data-gift-id'),0);
                return;
            }else if (target.classList.contains('multigift'))
            {
                _this.updateItem(target.getAttribute('data-gift-id'),1);
                return;
            }

        });

        var gap = 100 / (locks.length - 1);
        var current_target;
        var next_target;
        var last_target = locks[locks.length - 1];
        locks.forEach((target, i) => {
            const targetValue = target.getAttribute('data-target');
            if (progess_bar_val >= (targetValue * rate)) {
                current_target = target;
                next_target = locks[i + 1];

                setTimeout(function() {
                    target.classList.add("active");
                }, 300 * i);
            }
        });


        if (locks.length <= 2) {
            // document.querySelector('.mini-cart .top-wrap').style.display = 'none';
            let twr = document.querySelector('.mini-cart .top-wrap');
            if (twr) twr.style.display = 'none';
        }



        if (next_target) { // If next_target exists
            const currentTargetValue = parseFloat(current_target.getAttribute('data-target')) * rate;
            const nextTargetValue = parseFloat(next_target.getAttribute('data-target')) * rate;
            const extraval = (progess_bar_val - currentTargetValue) / (nextTargetValue - currentTargetValue);
            const barwidth = (Array.from(locks).indexOf(current_target) * gap) + (gap * extraval);
            setTimeout(function(){
            document.querySelector('.ns-progress-fill').style.width = barwidth + "%";
            document.querySelector('.ns-progress-fill')?.style.setProperty('width', barwidth + '%');
            },100);
        } else {
            setTimeout(function(){
                document.querySelector('.ns-progress-fill')?.style.setProperty('width', '100%');
            },100);
        }


    },  reloadOfferbar:function () {
        var rate = typeof market_exchange_rate !== 'undefined' ? market_exchange_rate : 1;
        var targets = document.querySelectorAll('[data-target]');

        targets.forEach(function(target) {
            var val = target.getAttribute('data-target');
            if (target.querySelector('sp')) {
                target.querySelector('sp').textContent = Math.round(val * rate / 100);
            }
        });
    },

    updateItem: function (id, le) {
        var _this = this;
        document.getElementById('mini-cart').classList.add('loading');
        fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: `quantity=${le}&id=${id}`,
        })
            .then((response) => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.json();
            })
            .then(() => {
                _this.updateCart();
            })
            .catch(() => {
                _this.updateCart();
            });
    },

    addItem: function (id) {
        var _this = this;
        document.getElementById('mini-cart').classList.add('loading');
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: `quantity=1&id=${id}`,
        })
            .then((response) => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.json();
            })
            .then(() => {
                _this.updateCart();
            })
            .catch(() => {
                _this.updateCart();
            });
    }
};


document.addEventListener('DOMContentLoaded', function() {
        PROJ.pdp.init();
        PROJ.ajaxcart.init();
});


document.addEventListener("DOMContentLoaded", () => {
    const c = new URLSearchParams(window.location.search).get('c');
    setTimeout(function(){
    document.querySelectorAll(`[data-color-click="${c}"]`).forEach(el => {
        el.click();
        document.querySelectorAll(`[data-c-tabtitle="${el.getAttribute('data-col-tab')}"]`).forEach(tab => tab.click());
    });},100);
});

// product page and popup product

document.addEventListener('click', function (e) {
    // Check if the clicked element has the attribute [data-c-tab]
    let el = e.target.closest('[data-c-tab]');
    let elp = e.target.closest('.op-wrap');

    let opssingle = e.target.closest('.pdp-quick .ops-single:not(.oos)');

    if (el) {
        const tabValue = el.getAttribute('data-c-tab');
        elp.querySelector('.col-list-wrap')
            .setAttribute('data-selected-tab', tabValue);
    }
    if (opssingle) {
        e.preventDefault();
        var optionInput = opssingle.closest('.op-wrap').querySelector('.op-input');
        optionInput.value = opssingle.getAttribute("data-value");
        opssingle.closest('.op-wrap').querySelectorAll('.ops-single').forEach(function(child) {
            child.classList.remove('active');
        });
        opssingle.classList.add('active');
        if(typeof updateStockBar === 'function') {
            if(opssingle.getAttribute("data-stock"))
            {
                setTimeout(function(){updateStockBar(opssingle.getAttribute("data-stock"));},100);
            }else
            {
                updateStockBar(100);
            }
        }
            if(opssingle.getAttribute("data-thumb-url"))
        {
            var imp = opssingle.getAttribute("data-thumb-url");
            checkImage(imp, function (exists) {
                if (exists) {
                    if(opssingle.closest('.vs-pdp-wrap'))
                    {
                        document.querySelector('.vs-main-gal .vs-med img')?.setAttribute('src',imp);
                        document.querySelector('.vs-main-gal .vs-med img')?.setAttribute('srcset',imp);

                        document.querySelector('.vs-thumb-gal .vs-thu img')?.setAttribute('src',imp);
                        document.querySelector('.vs-thumb-gal .vs-thu img')?.setAttribute('srcset',imp);
                        mainglalFlickty.select(0);
                    }
                    if(opssingle.closest('.exp-wrap'))
                    {
                        document.querySelector('.exp-wrap .exl img')?.setAttribute('src',imp);
                    }
                }
            });

            if(opssingle.getAttribute("data-thumb-back-url"))
            {
                var imp2 = opssingle.getAttribute("data-thumb-back-url");
                checkImage(imp, function (exists) {
                    if (exists) {
                        if(opssingle.closest('.vs-pdp-wrap'))
                        {
                            document.querySelectorAll('.vs-main-gal .vs-med')[1]?.querySelector('img')?.setAttribute('src',imp2);
                            document.querySelectorAll('.vs-main-gal .vs-med')[1]?.querySelector('img')?.setAttribute('srcset',imp2);

                            document.querySelectorAll('.vs-main-gal .vs-thu')[1]?.querySelector('img')?.setAttribute('src',imp2);
                            document.querySelectorAll('.vs-thumb-gal .vs-thu')[1]?.querySelector('img')?.setAttribute('srcset',imp2);
                            mainglalFlickty.select(0);
                        }
                    }
                });
            }

        }
    }
});


function checkImage(url, callback) {
    let img = new Image();
    img.onload = () => callback(true);
    img.onerror = () => callback(false);
    img.src = url;
}


// ordernote

    // Use event delegation for dynamically loaded content
    document.addEventListener('click', function(e) {
        if (e.target && e.target.matches('#cartNoteButton')) {
            const textarea = document.getElementById('cartNoteText');
            updateCartNote(textarea.value);
        }
        if (e.target && e.target.matches('.edit-note-link')) {
            e.preventDefault();
            const wrapper = document.querySelector('.cart-note-wrapper');
            wrapper.style.display = 'block';
        }


    });

    document.addEventListener('change', function(e) {
        if (e.target && e.target.matches('#cartNoteCheckbox')) {
            const wrapper = document.querySelector('.cart-note-wrapper');
            wrapper.style.display = e.target.checked ? 'block' : 'none';
            if (!e.target.checked) {
                updateCartNote('');
            }
        }
    });

    function updateCartNote(note) {
        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                note: note
            })
        })
        .then(response => response.json())
        .then(data => {
            const button = document.getElementById('cartNoteButton');
            const wrapper = document.querySelector('.cart-note-wrapper');
            const editLink = document.querySelector('.edit-note-link');

            if (button) button.textContent = note ? 'Update cart note' : 'Add note';
            if (wrapper) wrapper.style.display = 'none';
            if (editLink) editLink.style.display = note ? 'block' : 'none';
        })
        .catch(error => console.error('Error:', error));
    }
